// extracted by mini-css-extract-plugin
module.exports = {"root":"Board_root__1IqzY","container":"Board_container__WtlCg"};